import React, { useEffect, useState, useRef } from "react";
import {  useNavigate } from "react-router-dom";
import Switch from "@mui/material/Switch";
import "../../App.css";
import { BASE_URL } from "../../utils/config";
import FutureSection from "../../components/futuresection";
import OptionSection from "../../components/optionsection";
import NKBSection from "../../components/nkbsection";
import DeliverySection from "../../components/Deliverysection";

import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import Container from "react-bootstrap/Container";
import iconStockmarket from "../../images/icon-stockmarket-01.png";
import { styled } from "@mui/material/styles";
import iconOptions from "../../images/icon-stockmarket-02.png";
import iconDelivery from "../../images/icon-stockmarket-03.png";

import Loading from "../../components/loading";
import Sidebar from "../../components/sidebar";
import Report from "../report";
import TelegramWidget from "../../components/widget/telegramWidget";

const CreateReport = () => {
  const navigate = useNavigate();
  const [eventForm, setEventForm] = useState({
    eventType: "Options",
  });

  const imageRef = useRef();
  const [imageName, setImageName] = useState(null);
  const [checked, setChecked] = useState(true);
  const [intraDaychecked, setIntraDayChecked] = useState(false);
  const [secondtrgtchecked, setSecondTrgtChecked] = useState(false);
  const [freechecked, setFreechecked] = useState(false);
  const [deliveryIntraDayChecked, setDeliveryIntraDayChecked] = useState(false);
  const [isFormEditable, setIsFormEditable] = useState(true);
  const [imageUrl, setimageURL] = useState(null);
  const [base64ImageData, setBase64ImageData] = useState("");
  const [reportDate, setReportDate] = useState({});
  const [loading, setLoading] = useState(false);
  const [futureSectionState, setFutureSectionState] = useState({
    futureReportType: "BUY",
    stockType: "",
    cashCMP: "",
    futureCMP: "",
    stockIncToken: "",
    futureSL: 0,
    futureRemark:
      "Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.",
    commentry: "",
    chartImageInterval:'1D',
    Expiry: "",
    imageData: "",
    volume: "",
    lot_size: "",
  });
  const [FutureExpirySelected, setFutureExpirySelected] = useState([]);
  const [FutureStockSelected, setFutureStockSelected] = useState([]);

  const [optionSectionState, setOptionSectionState] = useState({
    optionReportType: "CALL",
    stockType: "",
    optionCMP: "",
    optionSL: 0,
    strikePrice: "",
    stockIncToken: "",
    underlayingPrice: "",
    optionRemark:
      "Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.",
    commentry: "",
    chartImageInterval:'1D',
    Expiry: "",
    volume: "",
    openInterest: "",
    lot_size: "",
  });


  const [OptionExpirySelected, setOptionExpirySelected] = useState([]);
  const [OptionStockSelected, setOptionStockSelected] = useState([]);

  const [deliverySectionState, setDeliverySectionState] = useState({
    deliveryReportType: "BUY",
    tradingsymbol: "NSE",
    stockType: "",
    deliveryCmp: "",
    stockIncToken: "",
    deliveryRemark1: "",
    deliveryRemark2: "",
    deliverySL: "",
    commentry: "",
    chartImageInterval:'1D',
    Signal: "Buy",
  });
  const [DeliveryStockSelected, setDeliveryStockSelected] = useState([]);

    const [nkbSectionState, setNkbSectionState] = useState({
      nkbReportType: 'CALL',
      stockType: '',
      optionCMP: '',
      optionSL: '0',
      stockIncToken: '',
      optionRemark: 'Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.',
      commentry: '',
      chartImageInterval:'1D'
    });
  const [stockLossRecord, setStockLossRecord] = useState({});
  const [stockSymbols, setStockSymbols] = useState([]);
  const [NSEstockSymbols, setNSEStockSymbol] = useState([]);
  const [BSEstockSymbols, setBSEStockSymbol] = useState([]);
  let NSEstock = [];
  let BSEstock = [];
  const [commenteryData, setCommenteryData] = useState([]);
  const [request_token, setRequestToken] = useState("");

  const [errorDialog, setErrorDialog] = useState(false);
  const [commonError, setCommonError] = useState(false);
  const [errormsg, setErrormsg] = useState("");
  const [futureError, setFutureError] = useState(false);
  const [optionError, setOptionError] = useState(false);
  const [deliveryError, setDeliveryError] = useState(false);
  const [ApiError, setApiError] = useState(false);
  const [RoleType, setRoleType] = useState("");
  const [alreadySubmit, setAlreadySubmit] = useState(false);
  const [imageGenerate, setImageGenerate] = useState(false);
  let count = 0;
  useEffect(() => {
    if (count === 0) {
      let roleType = JSON.parse(localStorage.getItem("roleType"));
      // console.log("roleType in side",roleType)
      setRoleType(roleType);
      if (roleType == "User") {
        setEventForm({ ...eventForm, eventType: "Options" });
        getstock("Future");
        getcommentery();
        count += 1;
      } else {
        getstock("Future");
        getcommentery();
        count += 1;
      }
    }
  }, []);


  //  update state when future section change
  const handleFutureSectionChange = (newFutureState) => {
    setFutureSectionState(newFutureState);
  };

  //  update state when future expiry  change
  const handleFutureExpirySelect = (newExpirySelected) => {
    setFutureExpirySelected(newExpirySelected);
  };

  // update state when future stock change
  const handleFutureStockSelect = (newStockSelected) => {
    setFutureStockSelected(newStockSelected);
    setBase64ImageData("");
    setimageURL("");
    setImageGenerate(false);
  };

  // update state when option section change
  const handleOptionSectionChange = (newOptionState) => {
    setOptionSectionState(newOptionState);
  };
  // update state when option section change
  const handleNKBSectionChange = (newOptionState) => {
    console.log("new state of nkb    ",newOptionState)
    setNkbSectionState(newOptionState);
  };

  // update state when option expiry change
  const handleOptionExpirySelect = (newExpirySelected) => {
    setOptionExpirySelected(newExpirySelected);
  };

  // update state when option stock change
  const handleOptionStockSelect = (newStockSelected) => {
    setOptionStockSelected(newStockSelected);
    setBase64ImageData("");
    setimageURL("");
    setImageGenerate(false);
  };

  // update state when delivery section change
  const handleDeliverySectionChange = (newDeliveryState) => {
    setDeliverySectionState(newDeliveryState);
  };

  // update state when delivery stock change
  const handleDeliveryStockSelect = (newStockSelected) => {
    setDeliveryStockSelected(newStockSelected);
    setBase64ImageData("");
    setimageURL("");
    setImageGenerate(false);
  };


  //  to handel api error function
  const handleApiError = () => {
    setErrorDialog(true);
    setApiError(true);

    setTimeout(() => {
      setErrorDialog(false);
      setApiError(false);
    }, 2000);
  };

  // to get Stock list
  const getstock = async (reportType) => {
    try {
      const response = await fetch(`${BASE_URL}/getstocklist/${reportType}`, {
        method: "GET",
      });

      if (!response.ok) {
        throw new Error(`Error : ${response.statusText}`);
      }

      const res = await response.json();

      if (res.success) {
        let data = res.delvieryData;
        NSEstock = data.filter((stock) => stock.segment === "NSE");
        BSEstock = data.filter((stock) => stock.segment === "BSE");

        if (NSEstock && BSEstock) {
          setNSEStockSymbol(NSEstock);
          setBSEStockSymbol(BSEstock);
          setStockSymbols(res.data);
          setRequestToken(res.request_token);
        }
      } else {
        handleApiError();
      }
    } catch (error) {
      handleApiError();
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };


  // to get commentery data
  const getcommentery = async () => {
    try {
      var eventDate = new Date();
      var day = eventDate.getDate();
      var monthNames = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      var month = monthNames[eventDate.getMonth()];
      var year = eventDate.getFullYear();

      var formattedDate = day + " " + month + " " + year;
      setReportDate(formattedDate);

      let loginuser = JSON.parse(localStorage.getItem("loginData"));
      
      const response = await fetch(`${BASE_URL}/getallcommentery`, {
        method: "GET",
        headers: {
          'Authorization': `Bearer ${loginuser.token}`
        }
      });

      if (!response.ok) {
        if (response.status === 403 || response.status === 401) {
          setTimeout(() => {
            localStorage.clear();
            navigate('/login');
          }, 3000);
        } else {
          throw new Error(`Error : ${response.statusText}`);
        }
        return;
      }

      const res = await response.json();

      if (res.success) {
        setCommenteryData(res.commenteryData[0]);
      } else {
        handleApiError();
        console.error("Failed to fetch commentery data:", res.message);
      }
    } catch (error) {
      handleApiError();
      console.error("Error fetching commentery data:", error);
    }
  };

  // to handle change report options like(future, option, delivery, hni ,etc)
  const handleSelectChange = async (event) => {
    if (event.target.value) {
      setLoading(true);
      console.log("seltect option", event.target.value);
      if (event.target.value === "Future") {
       

        setEventForm((prevState) => {
          const newState = {
            ...prevState,
            eventType: event.target.value,
          };
          return newState;
        });

        setOptionSectionState({
          optionReportType: "CALL",
          stockType: "",
          optionCMP: "",
          optionSL: "0",
          strikePrice: "",
          stockIncToken: "",
          underlayingPrice: "",
          optionRemark:
            "Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.",
          commentry: "",
          chartImageInterval:'1D',
          Expiry: "",
          volume: "",
          openInterest: "",
          lot_size: "",
        });
        setDeliverySectionState({
          deliveryReportType: "BUY",
          tradingsymbol: "NSE",
          stockType: "",
          deliveryCmp: "",
          deliveryRemark1: "",
          deliveryRemark2: "",
          deliverySL: "",
          stockIncToken: "",
          commentry: "",
          chartImageInterval:'1D',
          Signal: "Buy",
        });

        setNkbSectionState({
          nkbReportType: 'CALL',
      stockType: '',
      optionCMP: '',
      optionSL: '0',
      stockIncToken: '',
      optionRemark: 'Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.',
      commentry: '',
      chartImageInterval:'1D'
        })

        setimageURL("");
        setImageName(null);
        setIsFormEditable(true);
        setBase64ImageData("");
        setChecked(true);
        setIntraDayChecked(false);
        setSecondTrgtChecked(false);
        setFreechecked(false);
        setDeliveryIntraDayChecked(false);
        setAlreadySubmit(false);
        setLoading(false);
      }

      if (event.target.value === "Options") {
        // await getstock(event.target.value);
        setEventForm((prevState) => {
          const newState = {
            ...prevState,
            eventType: event.target.value,
          };
          return newState;
        });

        setFutureSectionState({
          futureReportType: "BUY",
          stockType: "",
          cashCMP: "",
          futureCMP: "",
          futureSL: "0",
          stockIncToken: "",
          futureRemark:
            "Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.",
          commentry: "",
          chartImageInterval:'1D',
          Expiry: "",
          imageData: "",
          base64Data: "",
          volume: "",
        });
        setDeliverySectionState({
          deliveryReportType: "BUY",
          tradingsymbol: "NSE",
          stockType: "",
          deliveryCmp: "",
          deliveryRemark1: "",
          stockIncToken: "",
          deliveryRemark2: "",
          deliverySL: "",
          commentry: "",
          chartImageInterval:'1D',
          Signal: "Buy",
        });
        setNkbSectionState({
          nkbReportType: 'CALL',
      stockType: '',
      optionCMP: '',
      optionSL: '0',
      stockIncToken: '',
      optionRemark: 'Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.',
      commentry: '',
      chartImageInterval:'1D'
        })
        setimageURL("");
        setImageName(null);
        setBase64ImageData("");
        setChecked(true);
        setIntraDayChecked(false);
        setSecondTrgtChecked(false);
        setFreechecked(false);
        setDeliveryIntraDayChecked(false);
        setIsFormEditable(true);
        setAlreadySubmit(false);
        setLoading(false);
      }

      if (event.target.value === "NKB") {
        // await getstock(event.target.value);
        setEventForm((prevState) => {
          const newState = {
            ...prevState,
            eventType: event.target.value,
          };
          return newState;
        });

       
        setOptionSectionState({
          optionReportType: "CALL",
          stockType: "",
          optionCMP: "",
          optionSL: 0,
          strikePrice: "",
          stockIncToken: "",
          underlayingPrice: "",
          optionRemark:
            "Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.",
          commentry: "",
          chartImageInterval:'1D',
          Expiry: "",
          volume: "",
          openInterest: "",
          lot_size: "",
        });

        setFutureSectionState({
          futureReportType: "BUY",
          stockType: "",
          cashCMP: "",
          futureCMP: "",
          futureSL: "0",
          stockIncToken: "",
          futureRemark:
            "Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.",
          commentry: "",
          chartImageInterval:'1D',
          Expiry: "",
          imageData: "",
          base64Data: "",
          volume: "",
        });
        setDeliverySectionState({
          deliveryReportType: "BUY",
          tradingsymbol: "NSE",
          stockType: "",
          deliveryCmp: "",
          deliveryRemark1: "",
          stockIncToken: "",
          deliveryRemark2: "",
          deliverySL: "",
          commentry: "",
          chartImageInterval:'1D',
          Signal: "Buy",
        });

        setimageURL("");
        setImageName(null);
        setBase64ImageData("");
        setChecked(true);
        setIsFormEditable(true);
        setAlreadySubmit(false);
        setLoading(false);
      }

      if (event.target.value === "Delivery") {
        
        setEventForm((prevState) => {
          const newState = {
            ...prevState,
            eventType: event.target.value,
          };
          return newState;
        });

        setFutureSectionState({
          futureReportType: "BUY",
          stockType: "",
          cashCMP: "",
          futureCMP: "",
          futureSL: "0",
          stockIncToken: "",
          futureRemark:
            "Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.",
          commentry: "",
          chartImageInterval:'1D',
          Expiry: "",
          imageData: "",
          base64Data: "",
          volume: "",
        });

        setDeliverySectionState({
          deliveryReportType: "BUY",
          tradingsymbol: "NSE",
          stockType: "",
          deliveryCmp: "",
          deliveryRemark1: "",
          stockIncToken: "",
          deliveryRemark2: "",
          deliverySL: "",
          commentry: "",
          chartImageInterval:'1D',
          Signal: "Buy",
        });

        setOptionSectionState({
          optionReportType: "CALL",
          stockType: "",
          optionCMP: "",
          optionSL: 0,
          strikePrice: "",
          stockIncToken: "",
          underlayingPrice: "",
          optionRemark:
            "Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.",
          commentry: "",
          chartImageInterval:'1D',
          Expiry: "",
          volume: "",
          openInterest: "",
          lot_size: "",
        });
    
        setNkbSectionState({
          nkbReportType: 'CALL',
      stockType: '',
      optionCMP: '',
      optionSL: '0',
      stockIncToken: '',
      optionRemark: 'Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.',
      commentry: '',
      chartImageInterval:'1D'
        })
        
        setIsFormEditable(true);
        setimageURL("");
        setImageName(null);
        setBase64ImageData("");
        setChecked(true);
        setIntraDayChecked(false);
        setSecondTrgtChecked(false);
        setFreechecked(false);
        setDeliveryIntraDayChecked(false);
        setAlreadySubmit(false);
        setLoading(false);
      }
      if (event.target.value === "HNI") {
        // await  getstock(event.target.value);
        setEventForm((prevState) => {
          const newState = {
            ...prevState,
            eventType: event.target.value,
          };
          return newState;
        });

        setFutureSectionState({
          futureReportType: "BUY",
          stockType: "",
          cashCMP: "",
          futureCMP: "",
          futureSL: "0",
          stockIncToken: "",
          futureRemark:
            "Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.",
          commentry: "",
          chartImageInterval:'1D',
          Expiry: "",
          imageData: "",
          base64Data: "",
          volume: "",
        });

        setOptionSectionState({
          optionReportType: "CALL",
          stockType: "",
          optionCMP: "",
          optionSL: 0,
          strikePrice: "",
          underlayingPrice: "",
          stockIncToken: "",
          optionRemark:
            "Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.",
          commentry: "",
          chartImageInterval:'1D',
          Expiry: "",
          volume: "",
          openInterest: "",
          lot_size: "",
        });

        setDeliverySectionState({
          deliveryReportType: "BUY",
          tradingsymbol: "NSE",
          stockType: "",
          deliveryCmp: "",
          deliveryRemark1: "",
          deliveryRemark2: "",
          deliverySL: "",
          stockIncToken: "",
          commentry: "",
          chartImageInterval:'1D',
          Signal: "Buy",
        });
        
        setNkbSectionState({
          nkbReportType: 'CALL',
      stockType: '',
      optionCMP: '',
      optionSL: '0',
      stockIncToken: '',
      optionRemark: 'Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.',
      commentry: '',
      chartImageInterval:'1D'
        })
        setIsFormEditable(true);
        setimageURL("");
        setImageName(null);
        setBase64ImageData("");
        setAlreadySubmit(false);
        setChecked(true);
        setIntraDayChecked(false);
        setSecondTrgtChecked(false);
        setFreechecked(false);
        setDeliveryIntraDayChecked(false);
        setLoading(false);
      }
    }
  };


  // to submit form data 
  const submitForm = async (event) => {
    event.preventDefault();
    setLoading(true);
    let stock = "";
    console.log("futureSectionState===========", futureSectionState);

    if (eventForm.eventType === "Future") {
      const cashCMPIsNumeric = /^\d*\.?\d{0,2}$/.test(
        futureSectionState.cashCMP
      );
      const futureCMPIsNumeric = /^\d*\.?\d{0,2}$/.test(
        futureSectionState.futureCMP
      );
      const futureSLIsNumeric = /^\d*\.?\d{0,2}$/.test(
        futureSectionState.futureSL
      );
      // console.log(futureSectionState, "futureSectionState");

      if (
        futureSectionState.cashCMP === "" ||
        futureSectionState.futureCMP === "" ||
        futureSectionState.futureSL === "" ||
        futureSectionState.stockType === "" ||
        futureSectionState.Expiry === "" ||
        futureSectionState.commentry === ""
      ) {
        // console.log("inside if");
        setLoading(false);
        setErrorDialog(true);
        setFutureError(true);

        setTimeout(() => {
          setErrorDialog(false);
          setFutureError(false);
          // alert("Please Enter Valid Details.")
        }, 2000);
        // return;
      } else if (!cashCMPIsNumeric) {
        // Your code for the case when all are numeric
        // console.log("inside if cmp");
        setLoading(false);
        setErrorDialog(true);
        setFutureError(true);

        setTimeout(() => {
          setErrorDialog(false);
          setFutureError(false);
          // alert("Please Enter Valid Details.")
        }, 2000);
      
      } else if (!futureCMPIsNumeric) {
        // console.log("inside if future cmp");
        setLoading(false);
        setErrorDialog(true);
        setFutureError(true);

        setTimeout(() => {
          setErrorDialog(false);
          setFutureError(false);

          // alert("Please Enter Valid Details.")
        }, 2000);
        // return; // Terminate the execution
      } else if (!futureSLIsNumeric) {
        // console.log("inside if future sl");
        setLoading(false);
        setErrorDialog(true);
        setFutureError(true);

        setTimeout(() => {
          setErrorDialog(false);
          setFutureError(false);
          // alert("Please Enter Valid Details.")
        }, 2000);
        // return;
      } else {
        // stock = futureSectionState.stockType;
        // generateReport(stock);
        setAlreadySubmit(true);
        const matchingStock = stockSymbols.find(
          (stock) => stock.name === futureSectionState.stockType
        );

        console.log("stock", matchingStock);

        generateReport(matchingStock.name, matchingStock.TVExchange);
      }
    } else if (eventForm.eventType === "Options") {
      const cashCMPIsNumeric = /^\d*\.?\d{0,2}$/.test(
        optionSectionState.optionCMP
      );
      const optionCMPIsNumeric = /^\d*\.?\d{0,2}$/.test(
        optionSectionState.underlayingPrice
      );
      const optionSLIsNumeric = /^\d*\.?\d{0,2}$/.test(
        optionSectionState.optionSL
      );
      const optionStrikepriceIsNumeric = /^\d*\.?\d{0,2}$/.test(
        optionSectionState.strikePrice
      );

      if (
        optionSectionState.optionCMP === "" ||
        optionSectionState.optionSL === "" ||
        optionSectionState.Expiry === "" ||
        optionSectionState.strikePrice === "" ||
        optionSectionState.stockType === "" ||
        optionSectionState.commentry === ""
        // optionSectionState.underlayingPrice === ""
      ) {
        setLoading(false);
        setErrorDialog(true);
        setOptionError(true);

        setTimeout(() => {
          setErrorDialog(false);
          setOptionError(false);
          // alert("Please Enter Valid Details.")
        }, 2000);
      } else if (!cashCMPIsNumeric) {
        setLoading(false);
        setErrorDialog(true);
        setOptionError(true);

        setTimeout(() => {
          setErrorDialog(false);
          setOptionError(false);
          // alert("Please Enter Valid Details.")
        }, 2000);
      }
      // else if (!optionCMPIsNumeric) {
      //   setLoading(false);
      //   setErrorDialog(true);
      //   setOptionError(true);

      //   setTimeout(() => {
      //     setErrorDialog(false);
      //     setOptionError(false);
      //     // alert("Please Enter Valid Details.")
      //   }, 2000);
      // }
      else if (!optionSLIsNumeric) {
        setLoading(false);
        setErrorDialog(true);
        setOptionError(true);

        setTimeout(() => {
          setErrorDialog(false);
          setOptionError(false);
          // alert("Please Enter Valid Details.")
        }, 2000);
      } else if (!optionStrikepriceIsNumeric) {
        setLoading(false);
        setErrorDialog(true);
        setOptionError(true);

        setTimeout(() => {
          setErrorDialog(false);
          setOptionError(false);
          // alert("Please Enter Valid Details.")
        }, 2000);
      } else {
      
        setAlreadySubmit(true);
        const matchingStock = stockSymbols.find(
          (stock) => stock.name === optionSectionState.stockType
        );

        console.log("stock", matchingStock);
        generateReport(matchingStock.name, matchingStock.TVExchange);
      }
    } else if (eventForm.eventType === "NKB") {
      const cashCMPIsNumeric = /^\d*\.?\d{0,2}$/.test(
        nkbSectionState.optionCMP
      );
    
      const optionSLIsNumeric = /^\d*\.?\d{0,2}$/.test(
        nkbSectionState.optionSL
      );

      if (
        nkbSectionState.optionCMP === "" ||
        nkbSectionState.optionSL === "" ||
        nkbSectionState.stockType === "" ||
        nkbSectionState.commentry === ""
       
      ) {
        setLoading(false);
        setErrorDialog(true);
        setOptionError(true);

        setTimeout(() => {
          setErrorDialog(false);
          setOptionError(false);
          // alert("Please Enter Valid Details.")
        }, 2000);
      } else if (!cashCMPIsNumeric) {
        setLoading(false);
        setErrorDialog(true);
        setOptionError(true);

        setTimeout(() => {
          setErrorDialog(false);
          setOptionError(false);
          // alert("Please Enter Valid Details.")
        }, 2000);
      }
     
      else if (!optionSLIsNumeric) {
        setLoading(false);
        setErrorDialog(true);
        setOptionError(true);

        setTimeout(() => {
          setErrorDialog(false);
          setOptionError(false);
          // alert("Please Enter Valid Details.")
        }, 2000);
      } else {
     
        setAlreadySubmit(true);
        const matchingStock = stockSymbols.find(
          (stock) => stock.name === nkbSectionState.stockType
        );

        console.log("stock", matchingStock);
        generateReport(matchingStock.name, matchingStock.TVExchange);
      }
    } else if (eventForm.eventType === "Delivery") {
      const cashCMPIsNumeric = /^\d*\.?\d{0,2}$/.test(
        deliverySectionState.deliveryCmp
      );
      const SLIsNumeric = /^\d*\.?\d{0,2}$/.test(
        deliverySectionState.deliverySL
      );
      // console.log("cashCMPIsNumeric", cashCMPIsNumeric, SLIsNumeric);

      if (
        deliverySectionState.deliveryCmp === "" ||
        deliverySectionState.stockType === "" ||
        deliverySectionState.Signal === "" ||
        deliverySectionState.commentry === ""
      ) {
        setLoading(false);
        setErrorDialog(true);
        setDeliveryError(true);

        setTimeout(() => {
          setErrorDialog(false);
          setDeliveryError(false);
        }, 2000);
      } else if (!cashCMPIsNumeric) {
        setLoading(false);
        setErrorDialog(true);
        setDeliveryError(true);

        setTimeout(() => {
          setErrorDialog(false);
          setDeliveryError(false);
        }, 2000);
      } else if (deliverySectionState.deliverySL === "" && !SLIsNumeric) {
        setLoading(false);
        setErrorDialog(true);
        setDeliveryError(true);

        setTimeout(() => {
          setErrorDialog(false);
          setDeliveryError(false);
        }, 2000);
      } else {
        
        setAlreadySubmit(true);
        if (deliverySectionState.tradingsymbol === "NSE") {
          const matchingStock = NSEstockSymbols.find(
            (stock) =>
              stock.name === deliverySectionState.stockType &&
              stock.segment === deliverySectionState.tradingsymbol
          );

          console.log("stock", matchingStock);

          generateReport(matchingStock.tradingsymbol, matchingStock.segment);
        } else {
          const matchingStock = BSEstockSymbols.find(
            (stock) =>
              stock.name === deliverySectionState.stockType &&
              stock.segment === deliverySectionState.tradingsymbol
          );

          console.log("stock", matchingStock);

          generateReport(matchingStock.tradingsymbol, matchingStock.segment);
        }
      }
    } else if (eventForm.eventType === "HNI") {
      const cashCMPIsNumeric = /^\d*\.?\d{0,2}$/.test(
        deliverySectionState.deliveryCmp
      );
      const SLIsNumeric = /^\d*\.?\d{0,2}$/.test(
        deliverySectionState.deliverySL
      );
      // console.log("cashCMPIsNumeric", cashCMPIsNumeric, SLIsNumeric);

      if (
        deliverySectionState.deliveryCmp === "" ||
        deliverySectionState.stockType === "" ||
        deliverySectionState.Signal === "" ||
        deliverySectionState.commentry === ""
      ) {
        setLoading(false);
        setErrorDialog(true);
        setDeliveryError(true);

        setTimeout(() => {
          setErrorDialog(false);
          setDeliveryError(false);
        }, 2000);
      } else if (!cashCMPIsNumeric) {
        setLoading(false);
        setErrorDialog(true);
        setDeliveryError(true);

        setTimeout(() => {
          setErrorDialog(false);
          setDeliveryError(false);
        }, 2000);
      } else if (deliverySectionState.deliverySL === "" && !SLIsNumeric) {
        setLoading(false);
        setErrorDialog(true);
        setDeliveryError(true);

        setTimeout(() => {
          setErrorDialog(false);
          setDeliveryError(false);
        }, 2000);
      } else {
       
        setAlreadySubmit(true);
        if (deliverySectionState.tradingsymbol === "NSE") {
          const matchingStock = NSEstockSymbols.find(
            (stock) =>
              stock.name === deliverySectionState.stockType &&
              stock.segment === deliverySectionState.tradingsymbol
          );

          console.log("stock", matchingStock);

          generateReport(matchingStock.tradingsymbol, matchingStock.segment);
        } else {
          const matchingStock = BSEstockSymbols.find(
            (stock) =>
              stock.name === deliverySectionState.stockType &&
              stock.segment === deliverySectionState.tradingsymbol
          );

          console.log("stock", matchingStock);

          generateReport(matchingStock.tradingsymbol, matchingStock.segment);
        }
      }
    }
  };

  // to generate report call image api if image is not generated or paste
  const generateReport = async (stock, stockType) => {
    try {
      if (!imageUrl) {
        if (!imageGenerate) {
          let intervaltime = '1D';
          if (eventForm.eventType === "Future") {
            intervaltime = futureSectionState.chartImageInterval;
          } else if (eventForm.eventType === "Options") {
            intervaltime = optionSectionState.chartImageInterval;
          } else if (eventForm.eventType === "Delivery") {
            intervaltime = deliverySectionState.chartImageInterval;
          } else if (eventForm.eventType === "HNI") {
            intervaltime = deliverySectionState.chartImageInterval;
          } else if (eventForm.eventType === "IntraDay") {
            intervaltime = optionSectionState.chartImageInterval;
          }

          const response = await fetch(`${BASE_URL}/getstockimage/${stock}/${stockType}/${intervaltime}`, {
            method: "GET",
            headers: {
              Accept: "image/png",
            },
          });

          if (!response.ok) {
            throw new Error(`Error : ${response.statusText}`);
          }

          const buffer = await response.arrayBuffer();
          const blob = new Blob([buffer], { type: "image/png" });
          const imageurl = URL.createObjectURL(blob);
          setimageURL(imageurl);

          const uint8Array = new Uint8Array(buffer);
          const base64String = uint8Array.reduce(
            (data, byte) => data + String.fromCharCode(byte),
            ""
          );
          const ImageData = btoa(base64String);
          setBase64ImageData(ImageData);

          setLoading(false);
        }
      } else if (imageName) {
        const base64ImageData = imageUrl.split(",")[1];
        setBase64ImageData(base64ImageData);
        setTimeout(() => {
          setLoading(false);
        }, 2000);
      } else {
        setTimeout(() => {
          setLoading(false);
        }, 2000);
      }
    } catch (error) {
      console.error("Error generating report:", error);
      setErrorDialog(true);
      setApiError(true);

      setTimeout(() => {
        setErrorDialog(false);
        setApiError(false);
      }, 2000);
    }
  };

  // to generate image from api 
  const generateImage = async (stock, stockType, intervaltime) => {
    try {
      setLoading(true);
      console.log("Inside generateImage function");

      if (!stock || !stockType || !intervaltime) {
        console.error("Missing required parameters: stock, stockType, or intervaltime");
        setErrormsg("Missing required parameters: stock, stockType, or intervaltime")
        setErrorDialog(true);
        setCommonError(true);

        setTimeout(() => {
          
          setErrorDialog(false);
          setCommonError(false);
          setErrormsg("")

        }, 2000);
        return;
      }

      const response = await fetch(`${BASE_URL}/getstockimage/${stock}/${stockType}/${intervaltime}`, {
        method: "GET",
        headers: {
          Accept: "image/png",
        },
      });

      if (!response.ok) {
        throw new Error(`Error: ${response.statusText}`);
      }

      const buffer = await response.arrayBuffer();
      const blob = new Blob([buffer], { type: "image/png" });
      const imageurl = URL.createObjectURL(blob);
      setimageURL(imageurl);
      setImageGenerate(true);

      if (blob) {
        const uint8Array = new Uint8Array(buffer);
        const base64String = uint8Array.reduce(
          (data, byte) => data + String.fromCharCode(byte),
          ""
        );
        const ImageData = btoa(base64String);

        setBase64ImageData(ImageData);
      }
    } catch (error) {

      try{ 
        let parts = stock.split('-');
        let newStockName = parts[0];

         const response = await fetch(`${BASE_URL}/getstockimage/${newStockName}/${stockType}/${intervaltime}`, {
          method: "GET",
          headers: {
            Accept: "image/png",
          },
        });
  
        if (!response.ok) {
          throw new Error(`Error: ${response.statusText}`);
        }
  
        const buffer = await response.arrayBuffer();
        const blob = new Blob([buffer], { type: "image/png" });
        const imageurl = URL.createObjectURL(blob);
        setimageURL(imageurl);
        setImageGenerate(true);
  
        if (blob) {
          const uint8Array = new Uint8Array(buffer);
          const base64String = uint8Array.reduce(
            (data, byte) => data + String.fromCharCode(byte),
            ""
          );
          const ImageData = btoa(base64String);
  
          setBase64ImageData(ImageData);
        }

      }catch(error){


        try{
          let newStockName = stock.replace('-', '_');

          const response = await fetch(`${BASE_URL}/getstockimage/${newStockName}/${stockType}/${intervaltime}`, {
            method: "GET",
            headers: {
              Accept: "image/png",
            },
          });
    
          if (!response.ok) {
            throw new Error(`Error: ${response.statusText}`);
          }
    
          const buffer = await response.arrayBuffer();
          const blob = new Blob([buffer], { type: "image/png" });
          const imageurl = URL.createObjectURL(blob);
          setimageURL(imageurl);
          setImageGenerate(true);
    
          if (blob) {
            const uint8Array = new Uint8Array(buffer);
            const base64String = uint8Array.reduce(
              (data, byte) => data + String.fromCharCode(byte),
              ""
            );
            const ImageData = btoa(base64String);
    
            setBase64ImageData(ImageData);
          }
        }catch(error){
          console.error("Error generating image:", error);
          setErrormsg(`Error generating image: ${error.message}`);
          setErrorDialog(true);
          setCommonError(true);
    
          setTimeout(() => {
            setErrorDialog(false);
            setCommonError(false);
            setErrormsg('');
          }, 2000);
        }
      }
     
    } finally {
      setLoading(false);
    }
  };

  // to cancel create report button
  const handleCancel = (event) => {
    event.preventDefault();
    // Reset main form state
    setEventForm({
      eventType: "Options", // Add other fields and their initial values as needed
    });
    setimageURL("");
    setImageName(null);
    setBase64ImageData("");
    setIsFormEditable(true);
    // Reset section states
    setFutureSectionState({
      futureReportType: "BUY",
      stockType: "",
      cashCMP: "",
      futureCMP: "",
      futureSL: 0,
      futureRemark: "",
      commentry: "",
      chartImageInterval:'1D',
      Expiry: "",
      imageData: "",
      base64Data: "",
      volume: "",
      lot_size: "",
    });

    setOptionSectionState({
      optionReportType: "CALL",
      stockType: "",
      optionCMP: "",
      optionSL: 0,
      strikePrice: "",
      underlayingPrice: "",
      optionRemark: "",
      commentry: "",
      chartImageInterval:'1D',
      Expiry: "",
      volume: "",
      openInterest: "",
      lot_size: "",
    });

    setNkbSectionState({
      nkbReportType: 'CALL',
      stockType: '',
      optionCMP: '',
      optionSL: '0',
      stockIncToken: '',
      optionRemark: 'Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.',
      commentry: '',
      chartImageInterval:'1D'
    })

    setDeliverySectionState({
      deliveryReportType: "BUY",
      tradingsymbol: "NSE",
      stockType: "",
      deliveryCmp: "",
      deliverySL: "",
      deliveryRemark1: "",
      deliveryRemark2: "",
      commentry: "",
      chartImageInterval:'1D',
      Signal: "Buy",
    });

    // Add any additional state resetting if needed
  };

  // to handle event change report type when report successfully created and sent to telegram
  const handleEventChangeOfTelegram = (newvalue) => {
    console.log("inside handleEventChangeOfTelegram", newvalue);
    setLoading(true);
    setEventForm({ ...eventForm, eventType: "" });
    setIsFormEditable(true);
    setTimeout(() => {
      if (newvalue === "Future") {
        setEventForm({ ...eventForm, eventType: newvalue });
        setFutureSectionState({
          futureReportType: "BUY",
          stockType: "",
          cashCMP: "",
          futureCMP: "",
          futureSL: "0",
          futureRemark:
            "Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.",
          commentry: "",
          chartImageInterval:'1D',
          Expiry: "",
          volume: "",
          lot_size: "",
        });
        setOptionSectionState({
          optionReportType: "CALL",
          stockType: "",
          optionCMP: "",
          optionSL: "0",
          strikePrice: "",
          underlayingPrice: "",
          optionRemark:
            "Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.",
          commentry: "",
          chartImageInterval:'1D',
          Expiry: "",
          volume: "",
          lot_size: "",
        });
        setNkbSectionState({
          nkbReportType: 'CALL',
      stockType: '',
      optionCMP: '',
      optionSL: '0',
      stockIncToken: '',
      optionRemark: 'Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.',
      commentry: '',
      chartImageInterval:'1D'
        })
        setDeliverySectionState({
          deliveryReportType: "BUY",
          tradingsymbol: "NSE",
          stockType: "",
          deliveryCmp: "",
          deliveryRemark1: "",
          deliveryRemark2: "",
          deliverySL: "",
          commentry: "",
          chartImageInterval:'1D',
          Signal: "Buy",
        });

        setimageURL("");
        setImageName(null);
        setBase64ImageData("");
        setChecked(true);
        setIntraDayChecked(false);
        setDeliveryIntraDayChecked(false);
        setSecondTrgtChecked(false);
        setFreechecked(false);
        setAlreadySubmit(false);
        setLoading(false);
      } else if (newvalue === "Options") {
        setEventForm({ ...eventForm, eventType: newvalue });

        setFutureSectionState({
          futureReportType: "BUY",
          stockType: "",
          cashCMP: "",
          futureCMP: "",
          futureSL: "0",
          futureRemark:
            "Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.",
          commentry: "",
          chartImageInterval:'1D',
          Expiry: "",
          volume: "",
          lot_size: "",
        });
        setOptionSectionState({
          optionReportType: "CALL",
          stockType: "",
          optionCMP: "",
          optionSL: "0",
          strikePrice: "",
          underlayingPrice: "",
          optionRemark: "",
          commentry: "",
          chartImageInterval:'1D',
          Expiry: "",
          volume: "",
          lot_size: "",
        });
        setDeliverySectionState({
          deliveryReportType: "BUY",
          tradingsymbol: "NSE",
          stockType: "",
          deliveryCmp: "",
          deliveryRemark1: "",
          deliveryRemark2: "",
          deliverySL: "",
          commentry: "",
          chartImageInterval:'1D',
          Signal: "Buy",
        });
        setNkbSectionState({
          nkbReportType: 'CALL',
      stockType: '',
      optionCMP: '',
      optionSL: '0',
      stockIncToken: '',
      optionRemark: 'Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.',
      commentry: '',
      chartImageInterval:'1D'
        })

        setimageURL("");
        setImageName(null);
        setBase64ImageData("");
        setChecked(true);
        setIntraDayChecked(false);
        setSecondTrgtChecked(false);
        setFreechecked(false);
        setDeliveryIntraDayChecked(false);
        setAlreadySubmit(false);
        setLoading(false);
      } else if (newvalue === "NKB") {
        setEventForm({ ...eventForm, eventType: newvalue });

        setFutureSectionState({
          futureReportType: "BUY",
          stockType: "",
          cashCMP: "",
          futureCMP: "",
          futureSL: "0",
          futureRemark:
            "Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.",
          commentry: "",
          chartImageInterval:'1D',
          Expiry: "",
          volume: "",
          lot_size: "",
        });
        setOptionSectionState({
          optionReportType: "CALL",
          stockType: "",
          optionCMP: "",
          optionSL: "0",
          strikePrice: "",
          underlayingPrice: "",
          optionRemark: "",
          commentry: "",
          chartImageInterval:'1D',
          Expiry: "",
          volume: "",
          lot_size: "",
        });
        setDeliverySectionState({
          deliveryReportType: "BUY",
          tradingsymbol: "NSE",
          stockType: "",
          deliveryCmp: "",
          deliveryRemark1: "",
          deliveryRemark2: "",
          deliverySL: "",
          commentry: "",
          chartImageInterval:'1D',
          Signal: "Buy",
        });

        setNkbSectionState({
          nkbReportType: 'CALL',
      stockType: '',
      optionCMP: '',
      optionSL: '0',
      stockIncToken: '',
      optionRemark: 'Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.',
      commentry: '',
      chartImageInterval:'1D'
        })

        setimageURL("");
        setImageName(null);
        setBase64ImageData("");
        setChecked(true);
        setIntraDayChecked(false);
        setSecondTrgtChecked(false);
        setFreechecked(false);
        setDeliveryIntraDayChecked(false);
        setAlreadySubmit(false);
        setLoading(false);
      } else if (newvalue === "Delivery") {
        setEventForm({ ...eventForm, eventType: newvalue });

        setFutureSectionState({
          futureReportType: "BUY",
          stockType: "",
          cashCMP: "",
          futureCMP: "",
          futureSL: "0",
          futureRemark:
            "Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.",
          commentry: "",
          chartImageInterval:'1D',
          Expiry: "",
          volume: "",
          lot_size: "",
        });
        setOptionSectionState({
          optionReportType: "CALL",
          stockType: "",
          optionCMP: "",
          optionSL: "0",
          strikePrice: "",
          underlayingPrice: "",
          optionRemark: "",
          commentry: "",
          chartImageInterval:'1D',
          Expiry: "",
          volume: "",
        });
        setDeliverySectionState({
          deliveryReportType: "BUY",
          tradingsymbol: "NSE",
          stockType: "",
          deliveryCmp: "",
          deliveryRemark1: "",
          deliveryRemark2: "",
          deliverySL: "",
          commentry: "",
          chartImageInterval:'1D',
          Signal: "Buy",
        });
        setNkbSectionState({
          nkbReportType: 'CALL',
      stockType: '',
      optionCMP: '',
      optionSL: '0',
      stockIncToken: '',
      optionRemark: 'Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.',
      commentry: '',
      chartImageInterval:'1D'
        })

        setimageURL("");
        setImageName(null);
        setBase64ImageData("");
        setChecked(true);
        setIntraDayChecked(false);
        setSecondTrgtChecked(false);
        setFreechecked(false);
        setDeliveryIntraDayChecked(false);
        setAlreadySubmit(false);
        setLoading(false);
      } else if (newvalue === "HNI") {
        setEventForm({ ...eventForm, eventType: newvalue });

        setFutureSectionState({
          futureReportType: "BUY",
          stockType: "",
          cashCMP: "",
          futureCMP: "",
          futureSL: "0",
          futureRemark:
            "Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.",
          commentry: "",
          chartImageInterval:'1D',
          Expiry: "",
          volume: "",
          lot_size: "",
        });
        setOptionSectionState({
          optionReportType: "CALL",
          stockType: "",
          optionCMP: "",
          optionSL: "0",
          strikePrice: "",
          underlayingPrice: "",
          optionRemark: "",
          commentry: "",
          chartImageInterval:'1D',
          Expiry: "",
          volume: "",
        });
        setDeliverySectionState({
          deliveryReportType: "BUY",
          tradingsymbol: "NSE",
          stockType: "",
          deliveryCmp: "",
          deliveryRemark1: "",
          deliveryRemark2: "",
          deliverySL: "",
          commentry: "",
          chartImageInterval:'1D',
          Signal: "Buy",
        });
        setNkbSectionState({
          nkbReportType: 'CALL',
      stockType: '',
      optionCMP: '',
      optionSL: '0',
      stockIncToken: '',
      optionRemark: 'Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.',
      commentry: '',
      chartImageInterval:'1D'
        })

        setimageURL("");
        setBase64ImageData("");
        setChecked(true);
        setIntraDayChecked(false);
        setSecondTrgtChecked(false);
        setFreechecked(false);
        setDeliveryIntraDayChecked(false);
        setAlreadySubmit(false);
        setImageName(null);
        setLoading(false);
      }
    }, 200);
    // setLoading(true)
  };

  // handle commentry radio button change 
  const handleChange = (event) => {
    event.preventDefault();

    setChecked(event.target.checked);
  };

  // handle intra day radio button change
  const handleIntraDayChange = (event) => {
    event.preventDefault();
    console.log("event.target.checked", event.target.checked);
    setSecondTrgtChecked(event.target.checked);
  };

  // handle free radio button  change
  const handleFreeChange = (event) => {
    event.preventDefault();
    console.log("event.target.checked", event.target.checked);
    setFreechecked(event.target.checked);
  };

  // handle delivery intra day radio button change
  const handleDeliveryIntraDayChange = (event) => {
    event.preventDefault();
    console.log("event.target.checked", event.target.checked);
    setDeliveryIntraDayChecked(event.target.checked);
  };


  const IOSSwitch = styled((props) => (
    <Switch
      focusVisibleClassName=".Mui-focusVisible"
      disableRipple
      {...props}
    />
  ))(({ theme }) => ({
    width: 42,
    height: 26,
    padding: 0,
    "& .MuiSwitch-switchBase": {
      padding: 0,
      margin: 2,
      transitionDuration: "300ms",
      "&.Mui-checked": {
        transform: "translateX(16px)",
        color: "#fff",
        "& + .MuiSwitch-track": {
          backgroundColor:
            theme.palette.mode === "dark" ? "#2ECA45" : "#23499E",
          opacity: 1,
          border: 0,
        },
        "&.Mui-disabled + .MuiSwitch-track": {
          opacity: 0.5,
        },
      },
      "&.Mui-focusVisible .MuiSwitch-thumb": {
        color: "#33cf4d",
        border: "6px solid #23499E",
      },
      "&.Mui-disabled .MuiSwitch-thumb": {
        color:
          theme.palette.mode === "light"
            ? theme.palette.grey[100]
            : theme.palette.grey[600],
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
      },
    },
    "& .MuiSwitch-thumb": {
      boxSizing: "border-box",
      width: 22,
      height: 22,
    },
    "& .MuiSwitch-track": {
      borderRadius: 26 / 2,
      backgroundColor: theme.palette.mode === "light" ? "#E9E9EA" : "#39393D",
      opacity: 1,
      transition: theme.transitions.create(["background-color"], {
        duration: 500,
      }),
    },
  }));


// to remove generated image from child component when stock name change
  const handleRemoveFileFromChild = () => {
    setimageURL(null);
    setBase64ImageData("");
    setImageName(null);
  };

  // to handle stock loss record change from child component
  const handleStockLossRecordChange = (newRecord) => {
    setStockLossRecord(newRecord);
  };

  // to handle image paste from clipboard
  const handlePaste = (e) => {
    e.preventDefault();
    const items = e.clipboardData.items;

    for (let i = 0; i < items.length; i++) {
      const item = items[i];

      if (item.type.indexOf("image") !== -1) {
        // e.preventDefault();
        const file = item.getAsFile();

        setImageName(file.name);
        const reader = new FileReader();
        reader.onloadend = () => {
          // Handle the base64-encoded image
          const base64Image = reader.result;
          // Send the base64-encoded image to the backend using FormData or perform other actions
          // console.log(base64Image);
          setimageURL(base64Image);
        };

        reader.readAsDataURL(file);
      }
    }
  };


  const handleContentChange = () => {
    imageRef.current.contentEditable = true;
  };

  // to handle form editable disable when submit button of child component press
  const handleEditableFromReport = () => {
    setIsFormEditable(false);
  };

  // to handle image cancel from child component
  const handleImageCancel = () =>{
    setImageName(null);
    setimageURL(null);
    setBase64ImageData("")
  };

  return (
  
    <>
      <Sidebar />
      <div className="create-report">
        <Container fluid style={{ padding: "0 40px" }}>
          {loading ? (
            <div
              style={{
                position: "fixed",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                zIndex: 2,
              }}
            >
              <Loading />
            </div>
          ) : null}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <h2 class="create-report-heading">Create report</h2>
            <h2 class="Preview-report-heading">Preview Screen</h2>
          </div>
          <div id="divcontent" className="divcontent">
            {/* <img className="img" src={rkblogo} alt="Logo" /> */}

            <form id="eventForm" className="eventForm">
              <div className="options">
                <div className="CreateReport-intraday">
                  <p className="event-type" htmlFor="eventtype">
                    Select Event Type:
                  </p>

                  <div className="selectbuttons">
                    <div
                      className="frame"
                      style={{
                        border:
                          eventForm.eventType === "Future"
                            ? "2px solid #23499E"
                            : null,
                      }}
                    >
                      <img className="icon" src={iconStockmarket} alt="Icon" />
                      <input
                        type="radio"
                        id="future"
                        value="Future"
                        name="eventtype"
                        onChange={handleSelectChange}
                      />
                      <p>Future</p>
                    </div>

                    <div
                      className="frame"
                      style={{
                        border:
                          eventForm.eventType === "Options"
                            ? "2px solid #23499E"
                            : null,
                      }}
                    >
                      <img className="icon" src={iconOptions} alt="Icon" />
                      <input
                        type="radio"
                        id="options"
                        value="Options"
                        name="eventtype"
                        onChange={handleSelectChange}
                      />
                      <p>Option</p>
                    </div>

                    <div
                      className="frame"
                      style={{
                        border:
                          eventForm.eventType === "NKB"
                            ? "2px solid #23499E"
                            : null,
                      }}
                    >
                      <img className="icon" src={iconOptions} alt="Icon" />
                      <input
                        type="radio"
                        id="NKB"
                        value="NKB"
                        name="eventtype"
                        onChange={handleSelectChange}
                      />
                      <p>NKB</p>
                    </div>

                    <div
                      className="frame"
                      style={{
                        border:
                          eventForm.eventType === "Delivery"
                            ? "2px solid #23499E"
                            : null,
                      }}
                    >
                      <img className="icon" src={iconDelivery} alt="Icon" />
                      <input
                        type="radio"
                        id="delivery"
                        value="Delivery"
                        name="eventtype"
                        onChange={handleSelectChange}
                      />
                      <p>Delivery</p>
                    </div>

                    {RoleType === "User" ? null : (
                      <div
                        className="frame"
                        style={{
                          border:
                            eventForm.eventType === "HNI"
                              ? "2px solid #23499E"
                              : null,
                        }}
                      >
                        <img className="icon" src={iconDelivery} alt="Icon" />
                        <input
                          type="radio"
                          id="hni"
                          value="HNI"
                          name="eventtype"
                          onChange={handleSelectChange}
                        />
                        <p>HNI</p>
                      </div>
                    )}
                  </div>
                
                <div>
                  <label style={{width:'25%'}} htmlFor="withCommentery">Commentary</label>

                  <IOSSwitch
                    sx={{ m: 1 }}
                    defaultChecked
                    checked={checked}
                    onChange={handleChange}
                    inputProps={{ "aria-label": "controlled" }}
                  />

                  {eventForm.eventType === "Options" ? (
                   
                   <>
                     <label  style={{width:'15%'}} htmlFor="intraDay">Free</label>

                     <IOSSwitch
                       sx={{ m: 1 }}
                       defaultChecked
                       checked={freechecked}
                       onChange={handleFreeChange}
                       inputProps={{ "aria-label": "controlled" }}
                     />
                   </>
                 
                  ) : null}

                  {eventForm.eventType === "IntraDay" ? (
                    <>
                    <>
                      <label  style={{width:'25%'}} htmlFor="intraDay">Second Target</label>

                      <IOSSwitch
                        sx={{ m: 1 }}
                        defaultChecked
                        checked={secondtrgtchecked}
                        onChange={handleIntraDayChange}
                        inputProps={{ "aria-label": "controlled" }}
                      />
                    </>
                      <>
                      <label  style={{width:'10%'}} htmlFor="intraDay">Free</label>

                      <IOSSwitch
                        sx={{ m: 1 }}
                        defaultChecked
                        checked={freechecked}
                        onChange={handleFreeChange}
                        inputProps={{ "aria-label": "controlled" }}
                      />
                    </>
                    </>
                  ) : null}

                  {eventForm.eventType === "Delivery" ? (
                    <>
                    <>
                      <label  style={{width:'20%'}} htmlFor="intraDay">IntraDay</label>

                      <IOSSwitch
                        sx={{ m: 1 }}
                        defaultChecked
                        checked={deliveryIntraDayChecked}
                        onChange={handleDeliveryIntraDayChange}
                        inputProps={{ "aria-label": "controlled" }}
                      />
                    </>
                     <>
                     <label  style={{width:'15%'}} htmlFor="intraDay">Free</label>

                     <IOSSwitch
                       sx={{ m: 1 }}
                       defaultChecked
                       checked={freechecked}
                       onChange={handleFreeChange}
                       inputProps={{ "aria-label": "controlled" }}
                     />
                   </>
                   </>
                  ) : null}
                  </div>
                </div>
              </div>
              <div className="form-report">
                {/* Future Buying Section */}
                {eventForm.eventType === "Future" ? (
                  <div id="futurebuyingDiv" className="future">
                    <FutureSection
                      stockSymbols={stockSymbols}
                      requestToken={request_token}
                      commenteryData={commenteryData}
                      isEditable={isFormEditable}
                      onFutureSectionChange={handleFutureSectionChange}
                      onFutureExpirySelect={handleFutureExpirySelect}
                      onFutureStockSelect={handleFutureStockSelect}
                      onRemoveFile={handleRemoveFileFromChild}
                      onStockLossRecord={handleStockLossRecordChange}
                      generateImage={generateImage}
                    />
                  </div>
                ) : null}

                {/* Option Buying Section */}
                {eventForm.eventType === "Options" ? (
                  <div id="optionbuyingDiv" className="option">
                    <OptionSection
                      stockSymbols={stockSymbols}
                      IntraDaychecked={intraDaychecked}
                      requestToken={request_token}
                      commenteryData={commenteryData}
                      isEditable={isFormEditable}
                      onOptionSectionChange={handleOptionSectionChange}
                      onOptionExpirySelect={handleOptionExpirySelect}
                      onOptionStockSelect={handleOptionStockSelect}
                      onRemoveFile={handleRemoveFileFromChild}
                      onStockLossRecord={handleStockLossRecordChange}
                      generateImage={generateImage}
                    />
                  </div>
                ) : null}
                {eventForm.eventType === "NKB" ? (
                  <div id="NKBDiv" className="NKB">
                    <NKBSection
                      stockSymbols={stockSymbols}
                      IntraDaychecked={true}
                      requestToken={request_token}
                      commenteryData={commenteryData}
                      isEditable={isFormEditable}
                      onNKBSectionChange={handleNKBSectionChange}
                      onOptionStockSelect={handleOptionStockSelect}
                      onRemoveFile={handleRemoveFileFromChild}
                      onStockLossRecord={handleStockLossRecordChange}
                      generateImage={generateImage}
                    />
                  </div>
                ) : null}

                {/* Delivery Report Section */}
                {eventForm.eventType === "Delivery" ? (
                  <div id="deliveryreportDiv" className="report">
                    <DeliverySection
                      stockSymbols={stockSymbols}
                      DeliveryIntraDayChecked={deliveryIntraDayChecked}
                      NSEStockSymbols={NSEstockSymbols}
                      BSEStockSymbols={BSEstockSymbols}
                      requestToken={request_token}
                      commenteryData={commenteryData}
                      isEditable={isFormEditable}
                      onDeliverySectionChange={handleDeliverySectionChange}
                      onDeliveryStockSelect={handleDeliveryStockSelect}
                      onRemoveFile={handleRemoveFileFromChild}
                      generateImage={generateImage}
                    />
                  </div>
                ) : null}

                {eventForm.eventType === "HNI" ? (
                  <div id="deliveryreportDiv" className="report">
                    <DeliverySection
                      stockSymbols={stockSymbols}
                      NSEStockSymbols={NSEstockSymbols}
                      BSEStockSymbols={BSEstockSymbols}
                      requestToken={request_token}
                      commenteryData={commenteryData}
                      isEditable={isFormEditable}
                      onDeliverySectionChange={handleDeliverySectionChange}
                      onDeliveryStockSelect={handleDeliveryStockSelect}
                      onRemoveFile={handleRemoveFileFromChild}
                      generateImage={generateImage}
                    />
                  </div>
                ) : null}

                <div className="ReportImagePick" id="stockimageInputDiv">
                  <p>Image:</p>
                  <div
                    className="Image-paste-box"
                    ref={imageRef}
                    contentEditable={imageName}
                    onPaste={handlePaste}
                    onInput={handleContentChange}
                  >
                    {imageName ? (
                      <div>
                        <p style={{ width: "100%" }}>Image Name: {imageName}</p>
                        <i className="pi pi-times" style={{margin: "auto", cursor: "pointer"}} onClick={handleImageCancel}></i>
                      </div>
                    ) : (
                      <p style={{ width: "100%" }}>Paste an image here...</p>
                    )}
                  </div>
                </div>

                <div className="btndiv">
                  <button
                    type="button"
                    onClick={handleCancel}
                    className="cancel-btn"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    onClick={submitForm}
                    className="submit-btn"
                  >
                    Submit
                  </button>
                </div>
              </div>
            </form>
         
            <div className="preview-screen">
              {eventForm.eventType === "Future" ? (
                <Report
                  reportChecked={checked}
                  eventType={eventForm.eventType}
                  SectionState={futureSectionState}
                  reportDate={reportDate}
                  imageUrl={imageUrl}
                  imageBuffer={base64ImageData}
                  selectedExpiryRecord={FutureExpirySelected}
                  selectedStockRecord={FutureStockSelected}
                  setEventChange={handleEventChangeOfTelegram}
                  stockLossRecord={stockLossRecord}
                  onSuccessSubmit={handleEditableFromReport}
                  isMCX={true}
                />
              ) : null}

              {eventForm.eventType === "Options" ? (
                <Report
                  reportChecked={checked}
                  IntraDayChecked={intraDaychecked}
                  FreeChecked={freechecked}
                  eventType={eventForm.eventType}
                  SectionState={optionSectionState}
                  reportDate={reportDate}
                  imageUrl={imageUrl}
                  imageBuffer={base64ImageData}
                  selectedExpiryRecord={OptionExpirySelected}
                  selectedStockRecord={OptionStockSelected}
                  setEventChange={handleEventChangeOfTelegram}
                  stockLossRecord={stockLossRecord}
                  onSuccessSubmit={handleEditableFromReport}
                />
              ) : null}

              {eventForm.eventType === "NKB" ? (
                <Report
                  reportChecked={checked}
                  IntraDayChecked={true}
                  SecondTarget={secondtrgtchecked}
                  FreeChecked={freechecked}
                  eventType={eventForm.eventType}
                  SectionState={nkbSectionState}
                  reportDate={reportDate}
                  imageUrl={imageUrl}
                  imageBuffer={base64ImageData}
                  selectedExpiryRecord={OptionExpirySelected}
                  selectedStockRecord={OptionStockSelected}
                  setEventChange={handleEventChangeOfTelegram}
                  stockLossRecord={stockLossRecord}
                  onSuccessSubmit={handleEditableFromReport}
                />
              ) : null}

              {eventForm.eventType === "Delivery" ? (
                <Report
                  reportChecked={checked}
                  DeliveryIntraDayChecked={deliveryIntraDayChecked}
                  FreeChecked={freechecked}
                  eventType={eventForm.eventType}
                  SectionState={deliverySectionState}
                  reportDate={reportDate}
                  imageUrl={imageUrl}
                  imageBuffer={base64ImageData}
                  selectedExpiryRecord={FutureExpirySelected}
                  selectedStockRecord={DeliveryStockSelected}
                  setEventChange={handleEventChangeOfTelegram}
                  stockLossRecord={stockLossRecord}
                  onSuccessSubmit={handleEditableFromReport}
                />
              ) : null}

              {eventForm.eventType === "HNI" ? (
                <Report
                  reportChecked={checked}
                  eventType={eventForm.eventType}
                  SectionState={deliverySectionState}
                  reportDate={reportDate}
                  imageUrl={imageUrl}
                  imageBuffer={base64ImageData}
                  selectedExpiryRecord={FutureExpirySelected}
                  selectedStockRecord={DeliveryStockSelected}
                  setEventChange={handleEventChangeOfTelegram}
                  stockLossRecord={stockLossRecord}
                  onSuccessSubmit={handleEditableFromReport}
                />
              ) : null}
            </div>
          

<TelegramWidget/>
          </div>

          <Dialog
            open={errorDialog}
            onClose={() => {
              setErrorDialog(false);
            }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                <div>
                  {futureError ? (
                    <span style={{ color: "black" }}>
                      <span style={{ color: "red" }}>*</span> Please Fill All
                      Mendatory Field.
                    </span>
                  ) : null}
                  {optionError ? (
                    <span style={{ color: "black" }}>
                      <span style={{ color: "red" }}>*</span> Please Fill All
                      Mendatory Field.
                    </span>
                  ) : null}
                  {deliveryError ? (
                    <span style={{ color: "black" }}>
                      <span style={{ color: "red" }}>*</span> Please Fill All
                      Mendatory Field.
                    </span>
                  ) : null}
                  {ApiError ? (
                    <span style={{ color: "black" }}>
                      We're sorry, but something went wrong while processing
                      your request.
                    </span>
                  ) : null}
                  {commonError ? (
                    <span style={{ color: "black" }}>
                     {errormsg}
                    </span>
                  ) : null}
                </div>
              </DialogContentText>
            </DialogContent>
          </Dialog>
        </Container>
      </div>
    </>
   
  );
};

export default CreateReport;
